import React from "react";
import "./Home.css";
import Product from "./Product";

function Home() {
  return (
    <div className="home">
      <img
        className="home_image"
        src="https://images-eu.ssl-images-amazon.com/images/G/02/digital/video/merch2016/Hero/Covid19/Generic/GWBleedingHero_ENG_COVIDUPDATE__XSite_1500x600_PV_en-GB._CB428684220_.jpg"
        alt="home"
      />
      <div className="home__row">
        <Product
          id="123212"
          title="Mac book Pro"
          price={99.9}
          rating={5}
          image="https://images-na.ssl-images-amazon.com/images/I/61aOa%2B4v4IL._AC_SL1240_.jpg"
        />

        <Product
          id="678953"
          title="Women off Shoulder Lace Dress Ladies Long Sleeve"
          price={60.4}
          rating={4}
          image="https://cf.shopee.ph/file/14d0d56f0d969a4c4a4ab8461d7c9ee4"
        />
      </div>

      <div className="home__row">
        <Product
          id="156788"
          title="Steel Pressure Cooker Set"
          price={40}
          rating={3}
          image="https://www.prestige.co.uk/media/catalog/product/cache/1/image/2000x2000/9df78eab33525d08d6e5fb8d27136e95/p/r/prestige_6l_clip_on_47289_pressure_cooker_handle_back_retouched_together.jpg"
        />

        <Product
          id="373282"
          title="HTC Desire 10 Pro "
          price={87.5}
          rating={5}
          image="https://images-na.ssl-images-amazon.com/images/I/51WMHT-HWLL._AC_.jpg"
        />

        <Product
          id="136792"
          title="Roku Wireless Speakers "
          price={65.5}
          rating={4}
          image="https://cigars.roku.com/v1/http%3A%2F%2Fimage.roku.com%2Fw%2Frapid%2Fimages%2Fpdp-carousel-items%2Fec9bf497-4e34-40cf-ae5a-18e5b2e72536.png"
        />
      </div>
      <div className="home__row">
        <Product
          id="113268"
          title="RCA RS32H2-EU ANDROID SMART LED TV"
          price={150}
          rating={4}
          image="https://cdn.webshopapp.com/shops/250788/files/309575012/rca-rca-rs32h2-eu-android-smart-led-tv.jpg"
        />
      </div>
    </div>
  );
}

export default Home;
